import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { Input } from '../../../../Forms';
export var NumberField = function NumberField(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onChange = _ref.onChange,
    size = _ref.size;
  var handleChange = function handleChange(newValue) {
    onChange(Number(newValue));
  };
  return React.createElement("div", null, React.createElement(Input, {
    textAlign: "center",
    formatType: "number",
    name: "field-".concat(field.field),
    value: value,
    onChange: handleChange,
    bordered: true,
    size: size
  }));
};